import React from 'react';
import CompanyForm from './CompanyForm';
import { companyActions } from '../../../redux/actions/company-action';
import { connect } from 'react-redux';
import {
  Grid,
  Row,
  Col
} from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";

class AddCompanyPage extends React.Component {
	constructor(props){
		super(props);
		this.state = {
			company : {},
			contact :[
				{ name:'', phone:'', email: '', password: '', type:{'name':'Primary Contact'} },
				{ name:'', phone:'', email: '', type:{'name':'Accounting Contact'} },
				{ name:'', phone:'', email: '', type:{'name':'Other Contact'} }
			],
			formType:'add',
		};
		this.handleAction = this.handleAction.bind(this);
	};
	handleAction(companyData){
		const { dispatch } = this.props;
	    dispatch(companyActions.storeCompany(companyData));
	};
	render(){
		return(
			<div className="content">
	        	<Grid fluid>
	          		<Row>
	            		<Col md={12}>
	              			<Card
				                title="Add Company"
				                content={
				                	<div>
			                            <Grid fluid>
			                                <Row>
			                                	<Col md={12}>
			                                		<CompanyForm handleActionParent={this.handleAction} companyDataFP = {this.state.company} companyContactDataFP = {this.state.contact} formType={this.state.formType} adminType="admin" />
			                                	</Col>
			                                </Row>
			                            </Grid>
			                        </div>
				                }
				            />
	             		</Col>
	            	</Row>
	          	</Grid>
	        </div>
		);
	};
}

function mapStateToProps(state) {
    const { loading } = state.companyReducer;
    
    return {
        loading
    };
}

const AddCompany = connect(mapStateToProps)(AddCompanyPage);
export default AddCompany;


// WEBPACK FOOTER //
// ./src/components/Admin/Company/AddCompany.jsx